function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { white, black, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Clear } from "@churchofjesuschrist/eden-icons";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { PanelStateContext } from "./panelState";
const BodyHeader = styled.header.withConfig({
  componentId: "sc-2fwp76-0"
})(["position:relative;display:flex;align-self:flex-start;align-items:center;min-height:2.5rem;width:100%;padding:0 ", ";background:", ";z-index:1;", ";"], spacing8, white, _ref => {
  let {
    preferredModeBreakWidth,
    preferredMode
  } = _ref;
  return `
    @media (min-width: ${preferredModeBreakWidth}) {
      ${preferredMode === "persistent" ? `display: none;` : ``}
    }
  `;
});
const Children = styled.div.withConfig({
  componentId: "sc-2fwp76-1"
})(["flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;"]);
const ClearContainer = styled(Icon).withConfig({
  componentId: "sc-2fwp76-2"
})(["line-height:0;cursor:pointer;"]);

const PanelHeader = _ref2 => {
  let {
    preferredMode,
    preferredModeBreakWidth,
    onClose,
    backButton,
    closePanelLabel,
    children,
    ...props
  } = _ref2;
  const panelStateContext = useContext(PanelStateContext);
  return /*#__PURE__*/React.createElement(BodyHeader, _extends({
    preferredMode: preferredMode ? preferredMode : panelStateContext.preferredMode,
    preferredModeBreakWidth: preferredModeBreakWidth ? preferredModeBreakWidth : panelStateContext.preferredModeBreakWidth,
    side: panelStateContext.side || "start"
  }, props), backButton ? /*#__PURE__*/React.createElement("div", null, backButton) : null, /*#__PURE__*/React.createElement(Children, null, children), /*#__PURE__*/React.createElement(ClearContainer, {
    onClick: onClose ? onClose : panelStateContext.onClose,
    "data-testid": "close-icon",
    "aria-label": closePanelLabel ? closePanelLabel : panelStateContext.closePanelLabel
  }, /*#__PURE__*/React.createElement(Clear, {
    color: black
  })));
};

PanelHeader.propTypes = {
  /** Content inside the panel header */
  children: PropTypes.node,

  /** Must be a single `<PanelBackButton>` element */
  backButton: PropTypes.element,

  /** Callback to execute when the panel is requested to close. If not supplied, inherits from parent panel. */
  onClose: PropTypes.func,

  /** Mode in which the panel should be displayed when the screen size is large enough for it. If not supplied, inherits from parent panel. */
  preferredMode: PropTypes.oneOf(["persistent", "overlay", "dismissible"]),

  /** `preferredMode` is respected when the viewport is above this breakpoint. If not supplied, inherits from parent panel. */
  preferredModeBreakWidth: PropTypes.string
};
export default PanelHeader;